import React from 'react'
import { Badge, Box, Stack } from '@mui/material'
import { styled } from '@mui/material/styles'
import { numberFormatCurrency } from '@fedsim/helpers'

import HealthBar from '../../progress-bar';
import ImageBlock from '../../image-block'
import { Caption, HeaderTertiary, HeaderBody, HeaderSecondary } from '../../typography'
import { NameBarStack } from '../../namebar'
import { DottedPaper } from '../../typography/dotted-paper'
import { WrestlerRecord } from '../../wrestler'
import CostIcon from '@mui/icons-material/MonetizationOn'

export const liSX = { width: '110px' }

const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: -3,
    top: 13,
    fontFamily: 'Open Sans',
    WebkitFontSmoothing: 'subpixel-antialiased',
    border: `2px solid ${theme.palette.background.paper}`,
    padding: '0 4px',
    zIndex: 0
  }
}))

export const BadgeUI = props => (
  <StyledBadge {...props}
    color="error" />
)

export const WrestlerItemStats = ({
  morale = null,
  stamina = null,
  popularity = null,
  charisma = null,
  damage = null
}) => {
  return (
    <Stack spacing={.5}
      sx={{ width: 250 }}>
      <HealthBar label="DMG"
        value={damage}
        backgroundColor="red"
        color="white" />
      <HealthBar label="STA"
        value={stamina} />
      <HealthBar label="POP"
        value={popularity} />
      <HealthBar label="MOR"
        value={morale} />
      <HealthBar label="CHAR"
        value={charisma} />
    </Stack>
  )
}

export const WrestlerItem = ({
  name = '',
  nickname = '',
  image = false,
  alignment = null,
  backgroundColor = '',
  brands = [],
  cost = null,
  children = null,

  losses = 0,
  wins = 0,
  streak = 0,

  charisma = null,
  stamina = null,
  morale = null,
  popularity = null,
  damage = null,
  points = 0
}) => {
  const alignmentLabel = alignment === "GOOD" ? "Cheered" : alignment === "BAD" ? "Boo'd" : false
  const costUI = numberFormatCurrency(cost) 
  return (
    <Box>
      <Stack
        spacing={2}
        sx={{
          width: '100%',
          alignItems: 'center',
          flexDirection: {
            xs: 'column',
            sm: 'column',
            md: 'row',
            lg: 'row',
            xl: 'row'
          },
          textAlign: {
            xs: 'center',
            sm: 'center',
            md: 'left',
            lg: 'left',
            xl: 'left'
          }
        }}>
        <ImageBlock image={image}
          size={100}
          backgroundColor={backgroundColor} />
        <Box sx={{
          width: 250
        }}>
          <Stack spacing={.5}>
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}>
              <HeaderSecondary>
                {name}
                {nickname && <HeaderTertiary>&quot;{nickname}&quot;</HeaderTertiary>}
              </HeaderSecondary>
              <Caption>{points}</Caption>
            </Box>
            <WrestlerRecord wins={wins}
              losses={losses}
              streak={streak} />
            <NameBarStack brands={brands} />
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            }}>
              {alignmentLabel && (
                <HeaderBody>
                  {alignmentLabel}
                </HeaderBody>
              )}
              {cost && (<Stack
                minWidth={180}
                alignItems="center"
                justifyContent="space-between"
                direction="row">
                <CostIcon />
                <Caption>
                  {costUI}
                </Caption>
              </Stack>)}
            </Box>
          </Stack>
        </Box>
        {charisma || stamina || morale || popularity || damage ? (
          <DottedPaper sx={{ m: 1 }}>
            <WrestlerItemStats {...{ charisma, stamina, damage, morale, popularity }} />
          </DottedPaper>
        ) : null}
      </Stack>
      <Box>{children}</Box>
    </Box>
  )
}
